/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fields_TitleInputs */

const en_fields_title = /** @type {(inputs: Fields_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fields`)
};

const de_fields_title = /** @type {(inputs: Fields_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felder`)
};

/**
* | output |
* | --- |
* | "Fields" |
*
* @param {Fields_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fields_title = /** @type {((inputs?: Fields_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fields_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fields_title(inputs)
	return en_fields_title(inputs)
});